module.exports = __webpack_public_path__ + "static/media/SINGLE-BREASTED 2 BUTTONS.ccc8c685.svg";